<div *ngIf="model">
  <div id="shopViewNewContainer" class="container">
    <div class="row">
      <div class="col-sm">
        <div class="product-preview">
          <div class="thumbnail-list">
            <div *ngFor="let image of mimes" (mouseenter)="onThumbnailHover(imageUrl(image))" class="thumbnail-item">
              <span *ngIf="!imageUrl(image)" class="glyphicon glyphicon-picture" style="font-size: 36px;"></span>
              <img *ngIf="imageUrl(image)" [src]="imageUrl(image)" loading="lazy" class="thumbnail"/>
            </div>
          </div>
          <div class="main-image">
            <span *ngIf="!selectedImage" class="glyphicon glyphicon-picture" style="font-size: 36px;"></span>
            <img *ngIf="selectedImage" [src]="selectedImage" alt="Selected Product Image" class="preview-image"/>
          </div>
        </div>
        <div class="row technicalFeaturesDiv">
          <div *ngIf="model?.technicalFeatures && nonVariantFeatureExists">
            <h6>{{ 'Produkteigenschaften' | translate }}</h6>
            <np-expandable-textview [maxHeight]="60">
              <div *ngFor="let feature of model?.technicalFeatures">
                <span *ngIf="!feature.isVariant">
                  <b>{{ feature.name }}:</b> {{ feature.value }} {{ feature.funit }}
                </span>
              </div>
            </np-expandable-textview>
          </div>
        </div>
      </div>
      <div class="col-sm product-infos">
        <div class="d-flex flex-row">
          <h5 class="me-2">{{ model?.descriptionShort }}</h5>
          <dx-button style="min-width:40px" icon="close" (onClick)="closeShopView()" height="40px"/>
        </div>
        <p>{{ model?.marketingClaim }}</p>
        <hr>
        <div *ngIf="model?.price?.prouctPrice">
          <h6>{{ model?.price.prouctPrice }}
            <span *ngIf="this.model.orderDetail.hasBasicPriceDuty" class="shopViewBasicPriceDuty"> ({{ basicPriceDutyInfo }})</span>
          </h6>
        </div>
        <div class="shoppingCart">
          <span class="shoppingCartOrderDetails">{{ model?.orderDetail.quantityMinNumber }} {{ orderUnit }}</span>
          <dx-button icon="cart"
                     text="{{ 'In den Warekorb' | translate }}"
                     hint="Dient nur zur Darstellung">
          </dx-button>
        </div>
        <div *ngIf="model?.technicalFeatures">
          <div *ngFor="let feature of model?.technicalFeatures">
            <div class="variantDiv" *ngIf="feature.isVariant">
              <dx-select-box [id]="feature.name"
                             [items]="getVariantValues(feature.name)"
                             [displayExpr]="displayItem"
                             valueExpr="value"
                             [label]="feature.name"
                             width="30%"
                             height="40px"
                             [(value)]="feature.value"
                             (onValueChanged)="onVariantValueChanged($event)">
              </dx-select-box>
            </div>
          </div>
        </div>
        <div class="shopviewProductInformations">
          <h6>{{ 'Produktinformationen' | translate }}</h6>
          <div *ngIf="model.supplierPid.length>0"><b>{{ 'Artikelnummer' | translate }}: </b>{{ model.supplierPid }}
          </div>
          <div *ngIf="model.internationalPid?.length>0">
            <b>{{ 'Internationale ID' | translate }}: </b>{{ model.internationalPid }}
          </div>
          <div *ngIf="model.manufacturerAid?.length>0">
            <b>{{ 'Herstellernummer' | translate }}: </b>{{ model.manufacturerAid }}
          </div>
          <div *ngIf="model.manufacturerName?.length>0">
            <b>{{ 'Hersteller' | translate }}: </b>{{ model.manufacturerName }}
          </div>
        </div>
        <div *ngIf="model?.productDataSheets.length > 0">
          <hr>
          <h6>{{ 'Produkdatenblätter' | translate }}</h6>
          <ul style="list-style: none;padding-left:0px;">
            <li *ngFor='let download of model.productDataSheets' class="dataSheetDownload">
              <a href="{{this.catalogService?.catalog?.id ? mediaService.getDownloadLink(this.catalogService?.catalog?.id,this.loginService.currentCustomer?.id ?? this.model.customerId,download.mimeSource) : ''}}" target="_blank"><img src="/images/Adobe_PDF_icon.svg" style="height: 20px;margin-right: 10px;">{{ download.mimeDescr }}</a>
            </li>
          </ul>
        </div>
        <div *ngIf="model?.topFeatures?.length > 0" class="topFeatures">
          <hr>
          <h6>{{ 'Topmerkmale' | translate }}</h6>
          <ul>
            <li *ngFor="let topFeature of model.topFeatures">
              {{ topFeature.value }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="row descriptionLongDiv">
      <div *ngIf="descriptionLongWithLegalInfo">
        <hr/>
        <h6>{{ 'Beschreibung' | translate }}</h6>
        <np-expandable-textview [maxHeight]="60">
          <div [innerHTML]="descriptionLongWithLegalInfo"></div>
        </np-expandable-textview>
      </div>
    </div>
    <div *ngIf="model?.references?.length > 0" class="row prouduct-refernces">
      <dx-tab-panel [dataSource]="referencePages">
        <div *dxTemplate="let item of 'item'" class="row referenceItemTemplate">
          <div *ngFor="let data of item.data" class="col-sm referenceItem">
            <div (click)="referenceClicked(data)">
              <div class="thumbnail-item">
                <span *ngIf="!data.normUri" class="glyphicon glyphicon-picture" style="font-size: 36px;"></span>
                <img *ngIf="data.normUri" [src]="data.normUri" class="thumbnail"/>
              </div>
              {{ data.descriptionShort }}
            </div>
          </div>
        </div>
      </dx-tab-panel>
    </div>
  </div>
</div>
